import Hero from 'components/hero';
import React from 'react';
import { ReactComponent as IconTick } from 'svg/icons/tick.svg';
import './style.css';

const EmployerControl = () => {
  return (
    <Hero layout="grid" className="employer-control">
      <div className="questions">
        <ul>
          <li>
            <IconTick className="tick" />
            <p>
              Is the process of filling vacant shifts becoming a strain on
              management time?
            </p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>
              Are the fees you are paying to Agencies a major dent in your
              bottom line?
            </p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>
              Do you feel out of control and too reliant on your recruitment
              agency for temporary workers?
            </p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>Does lack of staff leave you at risk of being non-compliant?</p>
          </li>
        </ul>
      </div>
      <div>
        <p>
          Even if you can only answer yes to one of these questions. MyShifts is
          a solution you may want to consider.
        </p>
        <p>
          Designed and created by Health and Social Care professionals for our
          sector and to provide a better way of operating for both providers and
          workers in a simple cost-effective way.
        </p>
      </div>
    </Hero>
  );
};

export default EmployerControl;
